// Contact details shown on the Kontakt page. They are not loaded from the database: enter them here.
// An empty field is not shown.
export const CONTACT = {
  company: "", // company name (shown slightly larger)
  address: "",
  city: "",
  web: "", // e.g. "www.firma.rs" or "https://www.firma.rs"
  email: "",
};

export const SUPPORT = {
  phone: "", // e.g. "+381 11 123 4567"
  email: "",
  subject: "Upit za tehničku podršku", // the only thing pre-filled in the message, the body stays empty
};
